import {
  Avatar,
  Checkbox,
  Divider,
  Grid,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { IMedication, MEDICATION_STATUSES } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleChecked, PurpleUnchecked } from 'Images';

interface IMedicationListItem {
  medication: IMedication;
  handleToggle: (medication: IMedication) => (e: React.MouseEvent) => void;
  outOfStockMedications: IMedication[];
  checkedMedications: IMedication[];
  showMedicationStatus: boolean;
  index: number;
}

export const MedicationListItem = ({
  handleToggle,
  medication,
  outOfStockMedications,
  checkedMedications,
  index,
}: IMedicationListItem) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicationsAndPrescriptionsLobby
  );

  return isDesktop ? (
    <ListItem>
      <Stack
        tabIndex={1}
        direction='row'
        alignItems='center'
        onClick={handleToggle(medication)}
        sx={{
          cursor: 'pointer',
          boxShadow: '-2px -2px 12px 0px rgba(8, 30, 84, 0.04)',
          borderRadius: '16px',
          backgroundColor: '#fff',
          p: '16px 24px',
          border: '1px solid',
          borderColor: 'primary.shade_200',
        }}
      >
        <ListItemIcon>
          <Checkbox
            edge='start'
            checked={
              medication.medstatus === MEDICATION_STATUSES.notAvailable
                ? outOfStockMedications.find(
                    (outOfStockMedication) =>
                      outOfStockMedication.medicatioN_CODE ===
                      medication.medicatioN_CODE
                  ) !== undefined
                : checkedMedications.find(
                    (checkedMedication) =>
                      checkedMedication.medicatioN_CODE ===
                      medication.medicatioN_CODE
                  ) !== undefined
            }
            tabIndex={-1}
            disableRipple
            inputProps={{ id: `check-med-${index}` }}
            icon={
              <Avatar
                alt=''
                src={PurpleUnchecked}
                sx={{ width: '24px', height: '24px' }}
              />
            }
            checkedIcon={
              <Avatar
                alt=''
                src={PurpleChecked}
                sx={{ width: '24px', height: '24px' }}
              />
            }
          />
        </ListItemIcon>
        <ListItemText
          disableTypography
          primary={
            <Grid container>
              <Grid item xs={12} md={5}>
                <label
                  style={{
                    pointerEvents: 'none',
                    fontSize: '18px',
                  }}
                  htmlFor={`check-med-${index}`}
                >
                  {medication.medicatioN_NAME}
                </label>
              </Grid>

              <Grid item xs={12} md={2}>
                <Typography variant='body3'>{medication.dosage}</Typography>
              </Grid>
              <Grid item xs={12} md={2}>
                <Typography variant='body3'>
                  {medication.doseperday === 1
                    ? dictionary.doseperday
                    : `${medication.doseperday} ${dictionary.doseperdays}`}
                </Typography>
              </Grid>
              <Grid item xs={12} md={2}>
                <Typography variant='body3'>
                  {medication.fornumberdays} {dictionary.days}
                </Typography>
              </Grid>
            </Grid>
          }
        />
      </Stack>
    </ListItem>
  ) : (
    <ListItem>
      <Stack
        tabIndex={1}
        direction='column'
        onClick={handleToggle(medication)}
        sx={{
          cursor: 'pointer',
          boxShadow: '-2px -2px 12px 0px rgba(8, 30, 84, 0.04)',
          borderRadius: '16px',
          backgroundColor: '#fff',
          p: '16px 16px 24px',
          border: '1px solid',
          borderColor: 'primary.shade_200',
        }}
      >
        <Stack flexDirection={'row'} alignItems={'start'}>
          <Checkbox
            edge='start'
            checked={
              medication.medstatus === MEDICATION_STATUSES.notAvailable
                ? outOfStockMedications.find(
                    (outOfStockMedication) =>
                      outOfStockMedication.medicatioN_CODE ===
                      medication.medicatioN_CODE
                  ) !== undefined
                : checkedMedications.find(
                    (checkedMedication) =>
                      checkedMedication.medicatioN_CODE ===
                      medication.medicatioN_CODE
                  ) !== undefined
            }
            tabIndex={-1}
            disableRipple
            inputProps={{ id: `check-med-${index}` }}
            icon={
              <Avatar
                alt=''
                src={PurpleUnchecked}
                sx={{ width: '24px', height: '24px' }}
              />
            }
            checkedIcon={
              <Avatar
                alt=''
                src={PurpleChecked}
                sx={{ width: '24px', height: '24px' }}
              />
            }
          />
          <label
            style={{
              pointerEvents: 'none',
              fontSize: '20px',
              marginTop: '8px',
            }}
            htmlFor={`check-med-${index}`}
          >
            {medication.medicatioN_NAME}
          </label>
        </Stack>

        <Divider
          aria-hidden='true'
          sx={{ borderColor: 'primary.shade_100', width: '100%', m: '16px 0' }}
        />

        <Typography variant='body3'>
          {medication.dosage} {dictionary.units}{' '}
          {medication.doseperday === 1
            ? dictionary.doseperday
            : `${medication.doseperday} ${dictionary.doseperdays}`}{' '}
          {dictionary.for} {medication.fornumberdays} {dictionary.days}
        </Typography>
      </Stack>
    </ListItem>
  );
};
